import { SvgProps } from "../../types";

const ConsumptionReport = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}>
    <path
      fill={props.fill ? props.fill : "#666D87"}
      d="M2.093 1.625v4.519-.019 7.5-12Zm1.5 7.5h2.625a4.27 4.27 0 0 1 .975-1.5h-3.6v1.5Zm0 3h2.381a4.295 4.295 0 0 1-.113-1.5H3.594v1.5Zm-1.5 3c-.413 0-.766-.147-1.06-.44a1.445 1.445 0 0 1-.44-1.06v-12c0-.413.147-.766.44-1.06.294-.293.647-.44 1.06-.44h6l4.5 4.5V6.5a4.332 4.332 0 0 0-.732-.234 6.158 6.158 0 0 0-.768-.122v-.769h-3.75v-3.75h-5.25v12h4.519c.2.3.425.578.675.834.25.257.525.479.825.666h-6.02Zm8.625-2.25a1.81 1.81 0 0 0 1.331-.544A1.81 1.81 0 0 0 12.593 11a1.81 1.81 0 0 0-.544-1.331 1.81 1.81 0 0 0-1.331-.544 1.81 1.81 0 0 0-1.331.544A1.81 1.81 0 0 0 8.843 11c0 .525.181.969.544 1.331a1.81 1.81 0 0 0 1.33.544Zm3.825 3-2.025-2.025a3.028 3.028 0 0 1-.853.394 3.425 3.425 0 0 1-.947.131c-.938 0-1.735-.328-2.39-.984-.657-.657-.985-1.454-.985-2.391 0-.938.328-1.734.984-2.39.656-.657 1.453-.985 2.39-.985.938 0 1.735.328 2.391.984.657.657.985 1.454.985 2.391 0 .325-.044.64-.132.947-.087.306-.218.59-.393.853l2.025 2.025-1.05 1.05Z"
    />
  </svg>
);
export default ConsumptionReport;
